import React from 'react';
import Button from '../../components/commons/Button';

function NotFound() {
  return (
    <div className="page-container text-center">
      <h1>404 - Page not found</h1>
      <h3>The page you are looking for cannot be found</h3>
      <Button size="large" kind="cancel" link="/">&larr; Go Back to home page</Button>
    </div>
  );
}

export default NotFound;
